module.exports = __webpack_public_path__ + "img/logo-orientequiteno.7f0da8f5.png";